import {
  get as getProp,
  isString,
} from 'lodash';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import sagas from './sagas';
import rootReducer from './rootReducers';
import { fetchUser, getIsAdmin } from '../services/auth';

export default function configureStore(initialState, history) {
  const credentials = fetchUser();
  const hydratedState = {
    ...initialState,
  };
  if (credentials) {
    const loginReducer = getProp(hydratedState, 'loginReducer', {});

    if (
      isString(credentials.accessToken) &&
      credentials.accessToken.split('.').length === 3
    ) {
      const isAdmin = getIsAdmin(credentials.accessToken);
      hydratedState.loginReducer = {
        ...loginReducer,
        accessToken: credentials.accessToken,
        identityToken: credentials.identityToken,
        isAdmin,
      };
    }
  }
  const sagaMiddleware = createSagaMiddleware();

  const middleware = applyMiddleware(sagaMiddleware, routerMiddleware(history));

  const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 25,
  });

  const store = composeEnhancers(middleware)(createStore)(rootReducer, hydratedState);

  sagaMiddleware.run(sagas, history);

  if (module.hot) {
    module.hot.accept('./rootReducers', () => {
      // eslint-disable-next-line global-require
      store.replaceReducer(require('./rootReducers'));
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/js/redux/configureStore.js